module.exports = __webpack_public_path__ + "static/media/Keyna Cory Headshot.9d023c9b.jpeg";